module.exports = __webpack_public_path__ + "static/media/point_icon_07.2f064ded.svg";